import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { fetchEventTables, type EventTable } from '../event-manager-client';

export function useEventTables(campaignId: string) {
  const { apiFetch } = useApi();

  const query = useQuery<EventTable[]>({
    queryKey: ['launcher', 'campaigns', campaignId, 'event-tables'],
    queryFn: () => fetchEventTables(apiFetch, campaignId),
    enabled: !!campaignId,
    staleTime: 0,
  });

  return {
    tables: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  } as const;
}
